import React from 'react';
import { motion } from 'framer-motion';

export const Card = ({
  children,
  className = '',
  hover = false,
  glow = false,
  ...props
}) => {
  return (
    <motion.div
      className={`
        bg-zinc-900/50 
        backdrop-blur-xl 
        border border-zinc-800/50 
        rounded-2xl 
        p-6
        ${hover ? 'transition-all duration-300 hover:border-zinc-700 hover:-translate-y-1 hover:shadow-xl hover:shadow-black/20' : ''}
        ${glow ? 'shadow-[0_0_40px_rgba(16,185,129,0.1)]' : ''}
        ${className}
      `}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export const GlassCard = ({
  children,
  className = '',
  intensity = 'medium',
  ...props
}) => {
  const intensities = {
    light: 'bg-zinc-900/30 backdrop-blur-md border-zinc-800/30',
    medium: 'bg-zinc-900/50 backdrop-blur-xl border-zinc-800/50',
    heavy: 'bg-zinc-900/70 backdrop-blur-2xl border-zinc-700/50',
  };

  return (
    <motion.div
      className={`
        ${intensities[intensity]}
        border 
        rounded-2xl 
        p-6
        ${className}
      `}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export const FeatureCard = ({
  icon: Icon,
  title,
  description,
  className = '',
}) => {
  return (
    <motion.div
      className={`
        bg-zinc-900/30 
        backdrop-blur-md 
        border border-zinc-800/50 
        rounded-2xl 
        p-6
        transition-all duration-300
        hover:bg-zinc-900/50
        hover:border-emerald-500/30
        hover:shadow-[0_0_30px_rgba(16,185,129,0.1)]
        group
        ${className}
      `}
      whileHover={{ y: -4 }}
    >
      {Icon && (
        <div className="w-12 h-12 rounded-xl bg-emerald-500/10 flex items-center justify-center mb-4 group-hover:bg-emerald-500/20 transition-colors">
          <Icon className="w-6 h-6 text-emerald-400" />
        </div>
      )}
      <h3 className="text-lg font-semibold text-zinc-100 mb-2">{title}</h3>
      <p className="text-zinc-400 text-sm leading-relaxed">{description}</p>
    </motion.div>
  );
};

export default Card;
